// Defaults should be set in their respective .env files. '' fallbacks are provided
// here to prevent TypeScript errors. Test defaults should be specified in .env.test
export const REACT_APP_ENV = process.env.REACT_APP_ENV || ''
export const CABLE_CONNECTION_URL = process.env.REACT_APP_CABLE_CONNECTION_URL
export const FALLBACK_CABLE_CONNECTION_URL = process.env.REACT_APP_FALLBACK_CABLE_CONNECTION_URL
export const CRDT_WS_URL = process.env.REACT_APP_CRDT_WS_URL || ''
export const ALGOLIA_APP_ID = process.env.REACT_APP_ALGOLIA_APP_ID || ''
export const ALGOLIA_INDEX_SUFFIX = process.env.REACT_APP_ALGOLIA_INDEX_SUFFIX || ''
export const ALGOLIA_SEARCH_PUBLIC_KEY = process.env.REACT_APP_ALGOLIA_SEARCH_PUBLIC_KEY || ''
export const REACT_APP_ALMANAC_IMAGE_SERVICE_URL = process.env.REACT_APP_ALMANAC_IMAGE_SERVICE_URL || ''
// eslint-disable-next-line no-restricted-properties
export const REACT_APP_API_URL = process.env.REACT_APP_API_URL || `${window.location.origin}/v1`
export const REACT_APP_READER_URL = process.env.REACT_APP_READER_URL || ''
export const REACT_APP_FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL || ''
export const REACT_APP_BACKEND_ORIGIN = process.env.REACT_APP_BACKEND_ORIGIN || ''
export const REACT_APP_INTERCOM_APP_ID = process.env.REACT_APP_INTERCOM_APP_ID || ''
export const REACT_APP_CALENDLY_URL = process.env.REACT_APP_CALENDLY_URL || ''
export const REACT_APP_CALENDLY_URL_ALTERNATIVE = process.env.REACT_APP_CALENDLY_URL_ALTERNATIVE || ''
export const REACT_APP_CLOUDINARY_API_KEY = process.env.REACT_APP_CLOUDINARY_API_KEY || ''
export const REACT_APP_CLOUDINARY_API_SECRET = process.env.REACT_APP_CLOUDINARY_API_SECRET || ''
export const REACT_APP_CLOUDINARY_CLOUD_NAME = process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || ''
export const REACT_APP_GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || ''
export const REACT_APP_GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || ''
export const REACT_APP_GOOGLE_REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI || ''
export const REACT_APP_GOOGLE_FONTS_API_KEY = process.env.REACT_APP_GOOGLE_FONTS_API_KEY || ''
export const REACT_APP_PUBLIC_URL = process.env.PUBLIC_URL || ''
export const REACT_APP_UNSPLASH_API_KEY = process.env.REACT_APP_UNSPLASH_API_KEY || ''
export const REACT_APP_GIPHY_API_KEY = process.env.REACT_APP_GIPHY_API_KEY || ''
export const REACT_APP_IFRAMELY_API_KEY = process.env.REACT_APP_IFRAMELY_API_KEY || ''
export const REACT_APP_STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY || ''
export const REACT_APP_GITHUB_CLIENT_ID = process.env.REACT_APP_GITHUB_CLIENT_ID || ''
export const HELP_DOC_KEY = process.env.REACT_APP_HELP_DOC_KEY || ''
export const REACT_APP_ALMANAC_IMPORT_SERVICE_URL = process.env.REACT_APP_ALMANAC_IMPORT_SERVICE_URL || ''
export const REACT_APP_HEAP_APP_ID = process.env.REACT_APP_HEAP_APP_ID || ''
export const REACT_APP_DISABLE_TRACKING = process.env.REACT_APP_DISABLE_TRACKING === 'true' || false
export const REACT_APP_JIRA_CLIENT_ID = process.env.REACT_APP_JIRA_CLIENT_ID || ''
export const REACT_APP_JIRA_REDIRECT_URL = process.env.REACT_APP_JIRA_REDIRECT_URL || ''
export const REACT_APP_ASANA_CLIENT_ID = process.env.REACT_APP_ASANA_CLIENT_ID || ''
export const REACT_APP_ASANA_REDIRECT_URL = process.env.REACT_APP_ASANA_REDIRECT_URL || ''
export const REACT_APP_BETA_ENVIRONMENT = process.env.REACT_APP_BETA_ENVIRONMENT || ''
export const REACT_APP_COMMIT_SHA = process.env.REACT_APP_COMMIT_SHA || ''
export const REACT_APP_BLAZE = process.env.REACT_APP_BLAZE === 'true' || false
export const REACT_APP_X_CLIENT_ID = process.env.REACT_APP_X_CLIENT_ID || ''
export const REACT_APP_X_REDIRECT_URI = process.env.REACT_APP_X_REDIRECT_URI || ''
export const REACT_APP_LINKEDIN_CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID || ''
export const REACT_APP_LINKEDIN_CLIENT_ID_V2 = process.env.REACT_APP_LINKEDIN_CLIENT_ID_V2 || ''
export const REACT_APP_LINKEDIN_REDIRECT_URI = process.env.REACT_APP_LINKEDIN_REDIRECT_URI || ''
export const REACT_APP_FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID || ''
export const REACT_APP_FACEBOOK_REDIRECT_URI = process.env.REACT_APP_FACEBOOK_REDIRECT_URI || ''
export const REACT_APP_INSTAGRAM_CONFIG_ID = process.env.REACT_APP_INSTAGRAM_CONFIG_ID || ''
export const REACT_APP_INSTAGRAM_REDIRECT_URI = process.env.REACT_APP_INSTAGRAM_REDIRECT_URI || ''
export const REACT_APP_FACEBOOK_CONFIG_ID = process.env.REACT_APP_FACEBOOK_CONFIG_ID || ''
export const REACT_APP_FACEBOOK_CONFIG_ID_V2 = process.env.REACT_APP_FACEBOOK_CONFIG_ID_V2 || ''
export const REACT_APP_TIKTOK_CLIENT_KEY = process.env.REACT_APP_TIKTOK_CLIENT_KEY || ''
export const REACT_APP_TIKTOK_REDIRECT_URI = process.env.REACT_APP_TIKTOK_REDIRECT_URI || ''
export const REACT_APP_YOUTUBE_CLIENT_ID = process.env.REACT_APP_YOUTUBE_CLIENT_ID || ''
export const REACT_APP_YOUTUBE_REDIRECT_URI = process.env.REACT_APP_YOUTUBE_REDIRECT_URI || ''
export const REACT_APP_MAILCHIMP_CLIENT_ID = process.env.REACT_APP_MAILCHIMP_CLIENT_ID || ''
export const REACT_APP_MAILCHIMP_REDIRECT_URI = process.env.REACT_APP_MAILCHIMP_REDIRECT_URI || ''

// Some dynamic variables to simplify the codebase
const { origin, host, hostname, protocol } = new URL(REACT_APP_FRONTEND_URL)
// http://localhost:3001 | https://almanac.io | https://yourreview.myalmanac.link
export const REACT_APP_FRONTEND_ORIGIN = origin || ''
// localhost:3001 | almanac.io | yourreview.myalmanac.link
export const REACT_APP_FRONTEND_HOST = host || ''
// localhost | almanac.io | yourreview.myalmanac.link
export const REACT_APP_FRONTEND_HOSTNAME = hostname || ''
// http: | https:
export const REACT_APP_FRONTEND_PROTOCOL = protocol || ''
